import { Money } from '../../common/Money';

export enum CollectionStatus {
  /** Открыт — работа по взысканию продолжается */
  OPEN = 'OPEN',
  /** Закрыт — деятельность по проекту прекращена */
  CLOSED = 'CLOSED',
}

export enum CollectionPaymentStatus {
  PAID = 'PAID',
  PLANNED = 'PLANNED',
}

/** Платёж по проекту взыскания: поступивший или запланированный департаментом. */
export class CollectionPaymentItem {
  constructor(
    public readonly uuid: string,
    public readonly paymentDate?: string,
    public readonly status?: CollectionPaymentStatus,
    public readonly totalSum?: Money
  ) {}
}

/**
 * Один проект взыскания ("Ход взыскания") по проекту на платформе.
 *
 * Долг проекта может взыскиваться несколькими строками реестра департамента — поэтому
 * sequence: показать идентификатор реестра нельзя, он содержит названия должника и
 * клиента, так что разделы нумеруются "Взыскание 1", "Взыскание 2".
 */
export class CollectionProgressItem {
  constructor(
    public readonly uuid: string,
    public readonly sequence: number,
    public readonly payments: ReadonlyArray<CollectionPaymentItem> = [],
    public readonly status?: CollectionStatus,
    public readonly addedAt?: string,
    public readonly publicClosedAt?: string,
    public readonly finishPlannedAt?: string,
    public readonly lastPaymentAt?: string,
    public readonly targetSum?: Money,
    public readonly paidSum?: Money,
    public readonly plannedSum?: Money,
    public readonly actualTargetSum?: Money,
    /** Доля, а не проценты: 1.1775 означает 117,75 %. */
    public readonly targetAchievementPercent?: number,
    public readonly strategyCategory?: string,
    public readonly collectionDays?: number
  ) {}
}

/**
 * Ответ GET /project/{uuid}/collection.
 *
 * Пустой items — норма, а не ошибка: данные по взысканию есть лишь у части проектов.
 */
export class CollectionProgress {
  constructor(public readonly items: ReadonlyArray<CollectionProgressItem> = []) {}
}

/** Проект платформы и ход взыскания по нему — строка страницы "Трек рекорд". */
export class TrackRecordProject {
  constructor(
    public readonly projectUuid: string,
    /** Всегда не пустой: проекты без данных по взысканию сюда не попадают. */
    public readonly items: ReadonlyArray<CollectionProgressItem>,
    /** Название на платформе, напр. "№563: ООО ...". */
    public readonly projectName?: string,
    public readonly projectNumber?: number
  ) {}
}

/** Ответ GET /project/collection-track-record — уже по номеру проекта по убыванию. */
export class TrackRecord {
  constructor(public readonly projects: ReadonlyArray<TrackRecordProject> = []) {}
}
